module.exports = __webpack_public_path__ + "static/media/accessory.a513f899.gif";